import { AdditionalStage } from '../../additionalStages/types';
import { AdditionalExercisesTypes, AdditionalExercisesAction, AdditionalExercise } from '../types';

export function getList(
    additionalExercises: AdditionalExercise[],
): AdditionalExercisesAction<{ additionalExercises: AdditionalExercise[] }> {
    return {
        type: AdditionalExercisesTypes.GET_LIST,
        payload: { additionalExercises },
    };
}

export function requestGetAdditionalExercisesList(ids: string[]): AdditionalExercisesAction<{ ids: string[] }> {
    return {
        type: AdditionalExercisesTypes.REQUEST_GET_LIST,
        payload: { ids },
    };
}

export function requestSaveAdditionalExercise(
    additionalStage: AdditionalStage,
    additionalExercise: AdditionalExercise,
): AdditionalExercisesAction<{ additionalStage: AdditionalStage; additionalExercise: AdditionalExercise }> {
    return {
        type: AdditionalExercisesTypes.REQUEST_SAVE_ADDITIONAL_EXERCISE,
        payload: { additionalStage, additionalExercise },
    };
}

export function saveAdditionalExercise(
    additionalExercise?: AdditionalExercise,
): AdditionalExercisesAction<{ additionalExercise?: AdditionalExercise }> {
    return {
        type: AdditionalExercisesTypes.SAVE_ADDITIONAL_EXERCISE,
        payload: { additionalExercise },
    };
}

export function deleteExercise(id?: string): AdditionalExercisesAction<{ id?: string }> {
    return {
        type: AdditionalExercisesTypes.DELETE_EXERCISE,
        payload: { id },
    };
}

export function requestDeleteExercise(
    id: string,
    tasks?: string[],
): AdditionalExercisesAction<{ id: string; tasks?: string[] }> {
    return {
        type: AdditionalExercisesTypes.REQUEST_DELETE_EXERCISE,
        payload: { id, tasks },
    };
}
